var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<li class=\"list-item list-item-clickable read-more\">\n    <div class=\"list-item-content\">\n        <div class=\"list-item-header\" style=\"text-align: center;\">\n            <div class=\"list-item-header-title\">\n                "
    + container.escapeExpression(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"module/word:readMore",{"name":"i18n","hash":{},"data":data}))
    + "\n            </div>\n        </div>\n    </div>\n</li>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./common/ui/template/behavior/readmore.hbs
// module id = 691
// module chunks = 0